const MUTATION_TYPE = {
  setFiles: 'setFiles',
  setWorkspace: 'setWorkspace'
}

const ACTION_TYPE = {
  fetchFiles: 'fetchFiles',
  uploadFiles: 'uploadFiles',
  fetchWorkspace: 'fetchWorkspace'
}

const GETTER_TYPE = {
  getFiles: 'getFiles',
  getWorkspace: 'getWorkspace'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
